const {enabled}=require('./transition.js');
const {track,clamp}=require('./scroll-driver.js');
document.querySelectorAll('[data-visuals]').forEach(section=>{
 const stage=section.querySelector('.one-visuals__stage');
 const panels=[...section.querySelectorAll('[data-visual-panel]')],buttons=[...section.querySelectorAll('[data-visual-select]')];
 buttons.forEach((button,index)=>button.addEventListener('click',()=>{
  panels[index]?.scrollIntoView({behavior:enabled()?'smooth':'instant',block:'center'});
  section.querySelector('[data-visual-status]').textContent=button.textContent;
 }));
 section.classList.add('is-ready');
 track(section,data=>{
  const positions=data.panels.map(panel=>({top:data.top+panel.top,height:panel.height}));
  const index=Math.max(0,positions.findLastIndex(panel=>panel.top<innerHeight*.65));
  buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(index===i)));
  positions.forEach((position,i)=>{
   const progress=clamp((innerHeight-position.top)/(innerHeight+position.height));
   panels[i].style.setProperty('--visual-turn',`${-8+progress*14}deg`);
   panels[i].style.setProperty('--visual-rise',`${(1-progress)*35}px`);
   panels[i].style.setProperty('--visual-scale',String(1.12-progress*.12));
  });
 },()=>({top:stage.getBoundingClientRect().top,panels:panels.map(panel=>({top:panel.offsetTop,height:panel.offsetHeight}))}),()=>{
  panels.forEach(panel=>['--visual-turn','--visual-rise','--visual-scale'].forEach(name=>panel.style.removeProperty(name)));
 });
 new IntersectionObserver(entries=>{
  section.classList.toggle('is-inview',entries[0].isIntersecting);
  if(entries[0].isIntersecting)panels.forEach(panel=>{const image=panel.querySelector('img');if(image){image.loading='eager';image.decode?.().catch(()=>{});}});
 },{rootMargin:'200px 0px'}).observe(section);
});
